/** Markenfarben — warmes Terracotta/Creme, vertrauenswürdig & wertig. */
export const brandColors = {
  /** Primär (Buttons, Links, Akzente) — Terracotta */
  primary: '#BF5A36',
  primaryDark: '#9C4528',
  primaryLight: '#DC9168',
  /** rgb-Komponenten für rgba(…) */
  primaryRgb: '191, 90, 54',
  /** Seitenleiste / Footer / dunkle Bänder (Espresso-Braun) */
  sidebar: '#2B1D16',
  /** Etwas helleres Braun für Stats-Bänder o. Ä. */
  bandDark: '#43342A',
  /** Cremiger Flächen-Hintergrund */
  cream: '#FBF7F2',
  /** Für Verläufe */
  gradientStart: '#BF5A36',
  gradientEnd: '#D98A4E',
  /** Vor-gebackener Hauptverlauf für Buttons, Banner, Hero-Bars etc. */
  gradient: 'linear-gradient(135deg, #BF5A36, #D98A4E)',
  /** Hover-Variante (dunkler) */
  gradientHover: 'linear-gradient(135deg, #9C4528, #C2763B)',
  /** Drei-Farb-Verlauf für Hero-Text-Akzente (warmer Sand-Endton) */
  gradientHero: 'linear-gradient(135deg, #BF5A36, #D98A4E, #E0A96D)',
  /** Sekundär-/Akzentfarben (warm) */
  coral: '#D96A4A',
  cyan: '#C98A5E',
  electricBlue: '#D98A4E',
  /** Serif-Display für editorial-warme Text-Akzente (Hero, Zitate) */
  displaySerif: '"Newsreader", Georgia, "Times New Roman", serif',
} as const;
